import { TextFieldProps } from "@mui/material";
import { Controller } from "react-hook-form";

import CustomTextField from "@/modules/signup/components/CustomTextField";
import SelectCountry from "@/modules/signup/components/SelectCountry";
import { ThemeVariant } from "@/utils/theme";

interface FormInputProps {
  control: any;
  name: string;
  label: string;
  themeVariant?: ThemeVariant;
  variant?: TextFieldProps["variant"];
  className?: string;
}

const FormInput = ({
  control,
  name,
  label,
  themeVariant = "dark",
  variant = "outlined",
  className,
}: FormInputProps) => {
  if (name === "country") {
    return (
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <SelectCountry
            className={className}
            field={field}
            label={label}
            themeVariant={themeVariant}
            variant={variant}
          />
        )}
      />
    );
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <CustomTextField
          className={className}
          {...field}
          sx={{ width: "300px" }}
          label={label}
          type={name === "email" ? "email" : "text"}
          required
          color="secondary"
          themeVariant={themeVariant}
          variant={variant}
        />
      )}
    />
  );
};

export default FormInput;
